export default class SelectMedia {
  constructor() {
    this.$item = $('.tab-item');
    this.$tabContainer = $('.article-content-wrap__item');
  }

  select() {
    this.$item.click((e) => {
      const target = $(e.currentTarget);
      const data = target.data('attr');
      this.refresh();

      this.$tabContainer.each((i, item) => {
        const itemData = $(item).data('attr');
        if (data === itemData) {
          $(item).addClass('active');
        }
      });
      SelectMedia.addActive(target, $(`[data-attr="${data}"]`));
    });
  }

  refresh() {
    this.$item.removeClass('active');
    this.$tabContainer.removeClass('active');
  }

  static addActive(tab, container) {
    tab.addClass('active');
    container.addClass('active');
  }

  init() {
    this.select();
  }
}
